<template lang="pug">
  svg: use(:xlink:href="require('@/assets/img/ui-graphics.svg') + iconID")
</template>

<script>
export default {
  name: 'UiIcon',

  // Props ---------------------------------------------------------------------
  props: {
    // SVG sprite icon id
    icon: {
      type: String,
      default: 'ui-not-found-icon'
    }
  },

  // Computed ------------------------------------------------------------------
  computed: {
    // Full icon ID
    iconID () {
      return '#' + this.icon
    }
  }
}
</script>
